import { render, staticRenderFns } from "./EChipRiscoEvasao.vue?vue&type=template&id=1205b5f2"
import script from "./EChipRiscoEvasao.vue?vue&type=script&lang=js"
export * from "./EChipRiscoEvasao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports